import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
jQuery(function ($) {
  if (!$('body.tax-product_cat, body.single-product').length) {
    return;
  }

  // Pre-open the branch of the currently viewed category in the mobile menu.
  // Deferred to a macrotask so it runs after the theme's mobileNavigation() ready
  // handler has appended the .xts-submenu-opener spans, keeping the toggle state in sync.
  setTimeout(function () {
    var $current = $('.xts-nav-mobile .current-menu-item');
    if (!$current.length) {
      return;
    }
    $current.add($current.parents('.xts-nav-mobile .menu-item-has-children')).filter('.menu-item-has-children').each(function () {
      var $li = $(this);
      $li.children('.xts-submenu-opener').addClass('xts-opened');
      $li.children('ul, div.xts-sub-menu').show();
    });
  }, 0);
});